import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { changeToINR } from "../../common/LookupConstants";
import HttpUtil from "../../common/HttpUtil";
import { ADJUSTMENTS_FOR_ADVANCE_API } from "../../common/Constants";
import { getDisplayDate, convertNumberToDate } from "../../lease/DateUtil";
import AlertComponent from "../../common/AlertComponent";
import TableList from "../../common/TableList";

class AdvanceAdjustmentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adjustAdvanceList: null
    };
  }

  // api failed  response alert to user
  handleApiFailed = message => {
    this.setState({
      //Default alert
      alertType: "Default",
      showAlert: true,
      alertColor: "danger",
      alertMessage: message
    });
  };

  // close alert message
  closeDefaultAlert = () => {
    this.setState({
      alertType: "",
      showAlert: false,
      alertColor: "",
      alertMessage: ""
    });
  };

  nameFormatter = (adjustmentTo, payment) => {
    let name = "";
    if (payment.entityType === "INDIVIDUAL") {
      const names = [];
      if (adjustmentTo.firstName) {
        names.push(adjustmentTo.firstName);
      }
      if (adjustmentTo.lastName) {
        names.push(adjustmentTo.lastName);
      }
      name = names.join(" ");
    } else {
      name = adjustmentTo.name;
    }
    return name;
  };

  dateFormatter = (cell, row) => {
    return getDisplayDate(convertNumberToDate(cell));
  };

  actionsFormater = (cell, row) => {
    let viewButton = (
      <Link to={`/finance/adjustment/advances/view/${row._id}`} role="button">
        <i
          className="fas fa-eye fa-lg action-icon"
          datatoggle="tooltip"
          title="View"
        />
      </Link>
    );
    return viewButton;
  };

  getAll = () => {
    const url = ADJUSTMENTS_FOR_ADVANCE_API;
    HttpUtil.get(
      url,
      {},
      data => {
        this.setState({ adjustAdvanceList: data });
      },
      (data, status) => this.handleApiFailed(data.message),
      error => this.handleApiFailed(error.toString())
    );
  };

  componentDidMount() {
    this.getAll();
  }
  render() {
    const columnsAdjustmentPayments = [
      {
        dataField: "adjustmentTo",
        text: "Name",
        sort: true,
        formatter: this.nameFormatter,
        csvFormatter: this.nameFormatter,
        filterValue: this.nameFormatter
      },
      {
        dataField: "amount",
        text: "Amount",
        formatter: changeToINR,
        headerClasses: "text-right",
        classes: "text-right",
        csvType: Number
      },
      {
        dataField: "date",
        text: "Date",
        formatter: this.dateFormatter,
        headerClasses: "text-center",
        classes: "text-center"
      },
      {
        dataField: "status",
        text: "Status",
        headerClasses: "text-center",
        classes: "text-center"
      },
      {
        dataField: "actions",
        text: "Actions",
        isDummyField: true,
        formatter: this.actionsFormater,
        headerClasses: "text-center",
        classes: "text-center",
        csvExport: false
      }
    ];

    const alertProps = {
      show: this.state.showAlert,
      type: this.state.alertType,
      alertColor: this.state.alertColor,
      message: this.state.alertMessage,
      close: this.closeDefaultAlert,
      confirm: this.okConfirmUpdate
    };
    return (
      <Fragment>
        <div className="row">
          <div className="col-12">
            {/* show alert message  */}
            <AlertComponent {...alertProps} />
          </div>
        </div>

        <TableList
          keyField="_id"
          columns={columnsAdjustmentPayments}
          data={this.state.adjustAdvanceList}
          noDataIndication="No Advance Adjustments found."
          sizePerPage="10"
          headerName="Advance Adjustments"
          showSearchbar={true}
          customComponent={<RenderCustomButton />}
        />
      </Fragment>
    );
  }
}

export default AdvanceAdjustmentList;

const RenderCustomButton = props => {
  return (
    <Link
      to="/finance/adjustment/advances/add"
      role="button"
      className="btn btn-sm text-white bg-pink"
    >
      New
    </Link>
  );
};
